export default class ContactMock {
    static get(query) {
        if (query.length > 0) {
            // console.log(query)
        }
        return ContactMock.getContacts()
    }
    static getContacts() {
        return {'data': {
                'contacts': [

                    {'id': 1,  
                        'prefix':"Dr",
                        'name': 'Wojciech ',
                        'surname': 'Strzelecki',
                        'imagesrc': 'contact2.jpg',
                        'description': 'Katedra i Zakład Psychologii Klinicznej </br> Uniwersytet Medyczny im. K. Marcinkowskiego w Poznaniu </br>ul. Bukowska 70, 60-812 Poznań',
                        'email': 'wojciech.strzelecki@interia.pl',
                        'phonenumber':'+48 609 293 602'
                    },
                    {'id': 0,
                        'prefix':"Dr",
                        'name': 'Anna',
                        'surname': 'Kostiukow',
                        'imagesrc': 'contact1.jpg',
                        'description': 'Katedra i Klinika Reumatologii i Rehabilitacji</br>Uniwersytet Medyczny im. K. Marcinkowskiego w Poznaniu </br>ul. 28 czerwca 1956r. nr 135-147, 61- 545 Poznań',
                        'email': 'annakostiukow@wp.pl',
                        'phonenumber':'+48 501 743 155' ,
						'gallery':['1.jpg','2.jpg','3.jpg','4.jpg']                       
                    },
					{'id': 2,
                         'prefix':"Mgr ",
                        'name': 'Piotr ',
                        'surname': 'Poniewierski',
                        'imagesrc': 'contact3.jpg',
                        'description': 'Katedra i Klinika Reumatologii i Rehabilitacji</br>Uniwersytet Medyczny im. K. Marcinkowskiego w Poznaniu </br>ul. 28 czerwca 1956r. nr 135-147, 61- 545 Poznań',
                        'email': 'piotrponiewierski@wp.pl ',
                        'phonenumber':'+48 508 729 490'  
                    }
                ]
            }
        }

    }
}



// WEBPACK FOOTER //
// ./src/static/api/mock/ContactMock.js